import React, { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Modal, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFolders,
  faPlus,
  faSortAlt,
  faCheck,
} from '@fortawesome/pro-solid-svg-icons'

import { useDispatch, useSelector } from 'react-redux'
import { IFolderModel } from 'models/folder.model'
import { ButtonVariant, ButtonSizes } from 'design-system/button/src/Button'
import Button from 'design-system/button'
import { IMainState } from 'store/states'
import { SuccessToast } from 'components/ui/toast/toastsTemplates'
import { IGeneralAPI } from 'store/states/general.state'
import * as fromActions from 'store/actions/general.action'
import List from './components/list/List'
import styles from './index.module.scss'
import { Config } from './components/Config'

const Folders: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [show, setShow] = useState(false)
  const [showCreate, setShowCreate] = useState(false)
  const [orderFolders, setOrderFolders] = useState(false)

  const [data, setData] = useState<IFolderModel[]>([])
  const { list } = useSelector(({ folders }: IMainState) => folders)

  const handleClose = () => {
    localStorage.removeItem('openFolder')
    setShow(false)
  }

  const handleShow = () => {
    localStorage.removeItem('openFolder')
    setShow(true)
  }

  const handleOrderFolder = () => {
    setOrderFolders(!orderFolders)
    setData(list)
  }

  const update = (data: Partial<IGeneralAPI>) => {
    dispatch(fromActions.Actions.update(data))
    SuccessToast(t('administration.toastMessages.editSuccess'))
  }
  
  // Folder component return

  return (
    <Fragment>
      <Button
        variant={ButtonVariant.Primary}
        size={ButtonSizes.Small}
        className={styles.button}
        onClick={handleShow}
      >
        <FontAwesomeIcon icon={faFolders} className={styles.setFont} />
        <span className={styles.setFont}>Carpetas</span>
      </Button>

      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className={styles.modalFolder}
        centered
      >
        <Modal.Header closeButton className="ml-3 mr-3 mt-2 pb-0">
          <Modal.Title>
            <p className={styles.headFont}>
              {t('administration.folders.title')}
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <List
            showCreate={showCreate}
            setShowCreate={setShowCreate}
            orderFolders={orderFolders}
            data={data}
            setData={setData}
          />
        </Modal.Body>
        <Modal.Footer className="ml-3 mr-3 mt-2 border-top-0">
          <div className="mr-auto">
            <Row noGutters>
              <Col xs="auto">
                <Button
                  variant={ButtonVariant.Success}
                  size={ButtonSizes.Small}
                  className={styles.button}
                  disabled={orderFolders}
                  onClick={() => setShowCreate(!showCreate)}
                >
                  <FontAwesomeIcon icon={faPlus} className={styles.setFont} />
                  {t('administration.folders.buttons.create')}
                </Button>
              </Col>
              <Col xs="auto">
                <Button
                  variant={
                    orderFolders
                      ? ButtonVariant.Success
                      : ButtonVariant.Secondary
                  }
                  size={ButtonSizes.Small}
                  className={styles.button}
                  onClick={handleOrderFolder}
                >
                  <FontAwesomeIcon
                    icon={orderFolders ? faCheck : faSortAlt}
                    className={styles.setFont}
                  />
                  {orderFolders
                    ? t('administration.folders.edit.buttons.save')
                    : t('administration.folders.buttons.order')}
                </Button>
              </Col>
              <Col xs="auto">
                <Config
                  update={update}
                  modalTitle={t(
                    'administration.folders.sortConfiguration.title'
                  )}
                />
              </Col>
            </Row>
          </div>

          <Button
            variant={ButtonVariant.Secondary}
            size={ButtonSizes.Small}
            onClick={handleClose}
          >
            {t('commons.buttons.close')}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}

export default Folders
